import { NavLink } from 'react-router-v7';
import { Theme, css } from '@emotion/react';

interface Props {
  text: string;
  /** Use `to` for SPA navigation within the v7 router. Use `href` for full-page navigation
   *  that needs to escape the v7 RouterProvider (e.g. back to the v5 SelectRoute at /). */
  to?: string;
  href?: string;
  hide?: boolean;
  variant?: 'primary' | 'secondary';
}

const clowncarMenuNavLinkRoot = ({ colors }: Theme) => css`
  color: ${colors.textLighter};
  &.is-active {
    color: ${colors.textWhite};
  }
`;

const ClowncarMenuNavLinkV7: React.FunctionComponent<Props> = ({
  text,
  to,
  href,
  hide,
  variant,
}) => {
  if (hide) {
    return null;
  }

  const content = (
    <span className="ClowncarMenu-navText" key="text">
      {text}
    </span>
  );
  const emotionCss = variant === 'primary' && clowncarMenuNavLinkRoot;

  if (href) {
    return (
      <a css={emotionCss} className="ClowncarMenu-navLink" href={href}>
        {content}
      </a>
    );
  }

  return (
    <NavLink
      css={emotionCss}
      className={({ isActive }) => `ClowncarMenu-navLink${isActive ? ' is-active' : ''}`}
      to={to ?? ''}
    >
      {content}
    </NavLink>
  );
};

export default ClowncarMenuNavLinkV7;
